import { useEffect } from 'react';

/**
 * Trava a rolagem da página enquanto o componente está montado (04/09, pedido
 * do mrolim): em `/chat` a página inteira não rola — quem rola é a transcrição.
 *
 * Só o `document.body`, e só pelo tempo da rota: ao desmontar volta o valor
 * **anterior** (inclusive um `overflow` inline que alguém tenha posto antes),
 * para o Shell e o Console de demonstração continuarem rolando como sempre. Um
 * `overflow: hidden` em CSS global valeria para todas as telas; o efeito vale
 * para esta.
 */
export function useBodyScrollLock(): void {
  useEffect(() => {
    const { style } = document.body;
    const previous = style.overflow;
    style.overflow = 'hidden';
    return () => {
      style.overflow = previous;
    };
  }, []);
}
